export const init = () => {
    if (document.querySelector('.header')) {
        const burger = document.querySelector('.js-header-burger');
        const content = document.querySelector('.js-header-content');
        const header = document.querySelector('.header');
        const languageSwitcher = header.querySelectorAll('.b-language-switcher');
        const navigationLink = document.querySelectorAll('.js-main-navigation-link');
        const navigationDropdown = document.querySelectorAll('.js-main-navigation-dropdown');
        const sideMenuLink = document.querySelectorAll('.js-side-menu-link');
        const contentDesktopContainer = document.querySelectorAll('.js-main-navigation-content-container');
        let tIn;
        const headerSearchBarContainer = document.querySelector('.header-top-info__search');
        const searchInput = headerSearchBarContainer.querySelector('.g-input__input-box');
        const closeSearchButton = headerSearchBarContainer.querySelector('.g-input__action--close');
        searchInput.addEventListener('input', () => {
            if (searchInput.value.trim() === "") {
                closeSearchButton.classList.remove('active');
            } else {
                if (!closeSearchButton.classList.contains('active')) {
                    closeSearchButton.classList.add('active');
                }
            }
        });
        closeSearchButton.addEventListener('click', () => {
            searchInput.value = "";
            closeSearchButton.classList.remove('active');
        });
        if (window.innerWidth > 1055) {
            window.addEventListener('scroll', () => {
                window.scrollY > 80 ? header.classList.add('header--scrolled') : header.classList.remove('header--scrolled');
            });
            document.querySelector('.js-account-button').addEventListener('mouseover',() => {
                document.querySelector('.js-account-info').classList.add('active');
            })
            document.querySelector('.js-account-button').addEventListener('mouseout',() => {
                document.querySelector('.js-account-info').classList.remove('active');
            })
            navigationLink.forEach((item, i) => {
                item.parentElement.addEventListener('mouseleave', () => {
                    navigationDropdown.forEach((curent) => {
                        curent.classList.remove('active');
                    })
                })
                item.addEventListener('mouseenter', () => {
                    tIn = setTimeout(() => {
                        navigationLink.forEach((item) => {
                            item.classList.remove('hovered');
                        });
                        item.classList.add('hovered');
                        navigationDropdown.forEach((curent, j) => {
                            if (i === (j+1)) {
                                navigationDropdown.forEach((item) => {
                                    item.classList.remove('active');
                                })
                                curent.classList.add('active');
                            }
                            if(i === 0) {
                                navigationDropdown.forEach((item) => {
                                    item.classList.remove('active');
                                })
                            }
                        })
                    },200)
                });
                item.addEventListener('mouseleave', () => {
                    clearTimeout(tIn);
                    item.classList.remove('hovered');
                });
            });
            sideMenuLink.forEach((item) => {
                item.addEventListener('mouseenter', () => {
                    tIn = setTimeout(() => {
                        sideMenuLink.forEach((curent) => {
                            if (curent.dataset.category === item.dataset.category) {
                                curent.classList.remove('active');
                            }
                        });
                        item.classList.add('active');
                        contentDesktopContainer.forEach((i) => {
                            [...i.children].forEach((curent) => {
                                if (curent.dataset.category === item.dataset.category) {
                                    curent.classList.remove('active');
                                }
                                if (curent.dataset.id === item.dataset.target) {
                                    curent.classList.add('active');
                                }
                            });
                        })
                    },200)
                });
                item.addEventListener('mouseleave', () => {
                    clearTimeout(tIn);
                })
            });
            contentDesktopContainer.forEach((i) => {
                [...i.children].forEach((curent) => {
                    if (curent.querySelector('.js-content-image-link') && curent.querySelector('.js-content-image')) {
                        curent.querySelector('.js-content-image').setAttribute('parent',curent.querySelector('.js-content-image').getAttribute('src'));
                        curent.querySelectorAll('.js-content-list').forEach((item) => {
                            item.addEventListener('mouseleave',() => {
                                curent.querySelector('.js-content-image').src = curent.querySelector('.js-content-image').getAttribute('parent');
                            })
                        });
                        curent.querySelectorAll('.js-content-image-link').forEach((item) => {
                            item.addEventListener('mouseover',() => {
                                curent.querySelector('.js-content-image').src = item.dataset.img;
                            })
                        })
                    }
                })
            })
        }
        else {
            burger.addEventListener('click', () => {
                burger.classList.toggle('active');
                content.classList.toggle('active');
            });
            header.classList.remove('header--scrolled');
            languageSwitcher.forEach((item) => {
                item.addEventListener('click', () => {
                    item.classList.toggle('active');
                });
            });
            sideMenuLink.forEach((item) => {
                item.classList.remove('active');
            });
            navigationLink.forEach((item, i) => {
                item.addEventListener('click', (e) => {
                    if (e.target === e.currentTarget) {
                        if (item.classList.contains('active')) {
                            item.classList.remove('active');
                            navigationDropdown.forEach((curent) => {
                                curent.classList.remove('active');
                            });
                            document.querySelectorAll('.js-main-navigation-link:not(.active)').forEach((item) => {
                                item.classList.remove('hidden');
                            });
                        }
                        else {
                            navigationLink.forEach((item) => {
                                item.classList.remove('active');
                            });
                            item.classList.add('active');
                            navigationDropdown.forEach((curent, j) => {
                                i == (j+1) ? curent.classList.add('active') : curent.classList.remove('active');
                            });
                            document.querySelectorAll('.js-main-navigation-link:not(.active)').forEach((item) => {
                                item.classList.add('hidden');
                            });
                        }
                    }
                });
            });
            sideMenuLink.forEach((item) =>{
                item.addEventListener('click', () => {
                    if (item.classList.contains('active')) {
                        item.classList.remove('active');
                        [...item.children].forEach((curent) => {
                            if (item.dataset.target === curent.dataset.id) {
                                curent.classList.remove('active');
                            }                   
                        });
                    }
                    else {
                        item.classList.add('active');
                        const containsDiv = Array.from(item.children).some(child => child.tagName.toLowerCase() === 'div');
                        if (item.children.length > 1 && containsDiv) {
                            [...item.children].forEach((curent) => {
                                if (item.dataset.target === curent.dataset.id) {
                                    curent.classList.add('active');
                                }                   
                            });
                        }
                        else {
                            contentDesktopContainer.forEach((i) => {
                                [...i.children].forEach((curent) => {
                                    if (item.dataset.target === curent.dataset.id) {
                                        item.appendChild(curent);
                                        curent.classList.add('active');
                                    }
                                });
                            });
                        }
                    }
                });
            });
        }
    }
}